module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bb-17738ccf41cecf9d38bae410178bc122.svg";